module.exports = __webpack_public_path__ + "static/img/bannerTxt1.ce4cb8ef.png";